/** Фотовьювер только один */
export const carouselDomId = 'photo-carousel'
